module.exports = __webpack_public_path__ + "static/media/cbd-structure.e10924be.png";